'use strict';

angular.module('atex.dam').controller('DamPrintModalController', ['$scope',
function($scope) {
  $scope.disabled = true;
  $scope.percent = 0;
  
  $scope.doPrint = function() {
    $scope.cancel();
  };
              
  $scope.$on("dam:print-document-success",function(event) {
    $scope.disabled=false;
  });
  
  $scope.$on("dam:print-document-percent",function(event,value) {
    $scope.percent = value;
    if(value === 100) {
      $scope.doPrint();
    }
  });
  
  $scope.$root.$broadcast('dam:print-form-loaded');
}
]);
